module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_inventory_reporting_period")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "棚卸報告年度区分"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c5826a8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0041_master_inventory_reporting_period.vue
// module id = 940
// module chunks = 0